import { Routes } from '@angular/router';
import { Permissions } from '@app/core/services/permission.service';
import { AuthGuardService } from '@app/security/auth-guard.service';
import { SetupSummaryComponent } from '@app/two-way/setup/components/setup-summary/setup-summary.component';
import { SetupContainerComponent } from '@app/two-way/setup/components/setup-container/setup-container.component';
import { SetupUsersComponent } from '@app/two-way/setup/components/setup-users/setup-users.component';
import { ControlTagsComponent } from '@app/two-way/control-tags/control-tags.component';
import { SetupSmsPingComponent } from '@app/two-way/setup/components/setup-sms-ping/setup-sms-ping.component';
import { SetupAutoResponseComponent } from '@app/two-way/setup/components/setup-auto-response/setup-auto-response.component';
import { MessagingComponent } from '@app/two-way/messaging/messaging.component';
import { RelayMessengerComponent } from '@app/two-way/relay-messenger/relay-messenger.component';
import { SetupConversationsComponent } from './setup/components/setup-conversations/setup-conversations.component';
import { FeatureFlags } from '@app/core/models/feature-flags';
import { SetupBusinessHoursComponent } from './setup/components/setup-business-hours/setup-business-hours.component';
import { UnsavedAutoResponseGuard } from './setup/guards/unsaved-auto-response.guard';
import { UnsavedPingMessagesGuard } from './setup/guards/unsaved-ping-messages.guard';

export const TwoWayRoutes: Routes = [
  {
    path: 'two-way/setup',
    component: SetupContainerComponent,
    canActivate: [AuthGuardService],
    data: {
      perm: Permissions.two_way_setup,
      config: 'two_way_config.enabled',
    },
    children: [
      {
        path: 'users',
        component: SetupUsersComponent,
        canActivate: [AuthGuardService],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
      {
        path: 'auto-response',
        component: SetupAutoResponseComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [UnsavedAutoResponseGuard],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
      {
        path: 'business-hours',
        component: SetupBusinessHoursComponent,
        canActivate: [AuthGuardService],
        data: {
          perm: Permissions.two_way_setup,
          flag: FeatureFlags.rm_auto_response,
        },
      },
      {
        path: 'sms-ping',
        component: SetupSmsPingComponent,
        canActivate: [AuthGuardService],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
      {
        // same as the above route, but for new Feed
        path: 'notification-ping',
        component: SetupSmsPingComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [UnsavedPingMessagesGuard],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
      {
        path: 'conversations',
        component: SetupConversationsComponent,
        canActivate: [AuthGuardService],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
      {
        path: 'summary',
        component: SetupSummaryComponent,
        canActivate: [AuthGuardService],
        data: {
          perm: Permissions.two_way_setup,
        },
      },
    ],
  },
  {
    path: 'two-way/control-groups',
    component: ControlTagsComponent,
    canActivate: [AuthGuardService],
    data: {
      perm: Permissions.two_way_setup,
      config: 'two_way_config.enabled',
    },
  },
  {
    path: 'two-way/messaging',
    component: MessagingComponent,
    canActivate: [AuthGuardService],
    data: {
      perm: Permissions.two_way_messaging,
      config: 'two_way_config.enabled',
    },
  },
  {
    path: 'two-way/relay-messenger',
    canActivate: [AuthGuardService],
    data: {
      perm: Permissions.two_way_messaging,
      config: 'two_way_config.enabled',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: RelayMessengerComponent,
      },
      {
        path: '**',
        component: RelayMessengerComponent,
      },
    ],
  },
];
